import type { ProtonThunkArguments } from '@proton/redux-shared-store-types/interface'

export interface DocsThunkArguments extends ProtonThunkArguments {}

export const extraThunkArguments = {} as DocsThunkArguments
